// The callback's business belongs to the server-side OAuth attempt. Never replace it
// with the current business selection, including on reload or a route remount.
export const EBAY_CLAIM_KEY = 'ebay_oauth_claim';
export const EBAY_CLAIM_CONTEXT_KEY = 'ebay_oauth_claim_context';

export const ebayClaimBusinessId = (value) => {
  if (!['string', 'number'].includes(typeof value) || !/^\d+$/.test(String(value))) return null;
  const id = Number(value);
  return Number.isSafeInteger(id) && id > 0 ? id : null;
};

export function readEbayClaimContext(claimToken) {
  try {
    const stored = JSON.parse(sessionStorage.getItem(EBAY_CLAIM_CONTEXT_KEY) || 'null');
    if (
      !claimToken ||
      sessionStorage.getItem(EBAY_CLAIM_KEY) !== claimToken ||
      stored?.claimToken !== claimToken
    )
      return null;
    const businessProfileId = ebayClaimBusinessId(stored.businessProfileId);
    return businessProfileId ? { claimToken, businessProfileId } : null;
  } catch {
    return null;
  }
}

export function captureEbayClaimContext(claimToken, businessId) {
  if (typeof claimToken !== 'string' || !claimToken) return null;
  try {
    const existing = readEbayClaimContext(claimToken);
    sessionStorage.setItem(EBAY_CLAIM_KEY, claimToken);
    // A later URL/global selection cannot retarget this token's recorded attempt.
    if (existing) return existing;
    const businessProfileId = ebayClaimBusinessId(businessId);
    sessionStorage.removeItem(EBAY_CLAIM_CONTEXT_KEY);
    if (!businessProfileId) return null;
    const context = { claimToken, businessProfileId };
    sessionStorage.setItem(EBAY_CLAIM_CONTEXT_KEY, JSON.stringify(context));
    return readEbayClaimContext(claimToken);
  } catch {
    return null;
  }
}

export function clearEbayClaimContext(claimToken) {
  try {
    // A late response from an old component must never erase a newer attempt.
    if (sessionStorage.getItem(EBAY_CLAIM_KEY) !== claimToken) return;
    sessionStorage.removeItem(EBAY_CLAIM_KEY);
    sessionStorage.removeItem(EBAY_CLAIM_CONTEXT_KEY);
  } catch {
    // The mounted page still discards its in-memory token.
  }
}
